/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../styles/PolicyAreaSelection.css";
import MultiStepBar from "../components/MultiStepBar";
import { fetchPolicyCard } from "../api/fetchPolicyCard";

const POLICY_AREAS = [
  {
    id: "environment",
    name: "Environment",
    icon: "env-icon",
    description: "Climate action, conservation, renewable energy",
  },
  {
    id: "economy",
    name: "Economy",
    icon: "econ-icon",
    description: "Taxation, budget, jobs, trade",
  },
  {
    id: "healthcare",
    name: "Healthcare",
    icon: "health-icon",
    description: "Medicare, public health, aged care",
  },
  {
    id: "education",
    name: "Education",
    icon: "edu-icon",
    description: "Schools, universities, research",
  },
  {
    id: "immigration",
    name: "Immigration",
    icon: "imm-icon",
    description: "Border policy, refugees, visas",
  },
  {
    id: "defense",
    name: "Defense",
    icon: "def-icon",
    description: "Military, security, alliances",
  },
  {
    id: "social",
    name: "Social Services",
    icon: "soc-icon",
    description: "Welfare, disability, seniors, family",
  },
  {
    id: "justice",
    name: "Justice",
    icon: "jus-icon",
    description: "Laws, courts, police, corrections",
  },
  {
    id: "infrastructure",
    name: "Infrastructure",
    icon: "infra-icon",
    description: "Transport, housing, urban development",
  },
  {
    id: "foreign",
    name: "Foreign Affairs",
    icon: "foreign-icon",
    description: "Diplomacy, aid, international relations",
  },
];

export default function PolicyAreaSelection() {
  const navigate = useNavigate();
  const [selectedAreas, setSelectedAreas] = useState({});
  const [errorMessage, setErrorMessage] = useState("");
  const steps = ["Select Areas", "Swipe Cards", "See Matches"];
  const currentStep = 1; // for example
  const [loading, setLoading] = useState(true);
  // Check for existing selections in localStorage on component mount
  useEffect(() => {
    const storedAreas = localStorage.getItem("selectedPolicyAreas");
    if (storedAreas) {
      setSelectedAreas(JSON.parse(storedAreas));
    }
  }, []);

  const toggleArea = (areaId) => {
    setSelectedAreas((prev) => ({
      ...prev,
      [areaId]: !prev[areaId],
    }));
    setErrorMessage("");
  };

  const selectAll = () => {
    const allSelected = {};
    POLICY_AREAS.forEach((area) => {
      allSelected[area.id] = true;
    });
    setSelectedAreas(allSelected);
    setErrorMessage("");
  };

  const deselectAll = () => {
    setSelectedAreas({});
    localStorage.setItem("selectedPolicyAreas", JSON.stringify({}));

  };

  const handleContinue = () => {
    // Check if at least one area is selected
    const hasSelection = Object.values(selectedAreas).some((value) => value);

    if (!hasSelection) {
      setErrorMessage("Please select at least one policy area");
      return;
    }

    // Save selections to localStorage
    localStorage.setItem("selectedPolicyAreas", JSON.stringify(selectedAreas));

    try {
      // Show loading state if needed
      setLoading(true);

      // Get only the selected areas (filtering out false values)
      const selectedAreaIds = Object.keys(selectedAreas).filter(
        (key) => selectedAreas[key]
      );

      fetchPolicyCard(selectedAreaIds)
        .then((data) => {
          localStorage.setItem("policyCards", JSON.stringify(data));
          // Navigate to the swipe page with the data
          navigate("/policy-swipe/swipe", {
            state: { policyCards: data.cards },
          });
        })
        .catch((err) => {
          console.error("Error fetching policy cards:", err);
          setLoading(false);
        });

      // Store the policy cards in localStorage or state management
    } catch (error) {
      console.error("Error fetching policy cards:", error);
      setErrorMessage("Error loading policy cards. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // Count selected areas
  const selectedCount = Object.values(selectedAreas).filter(Boolean).length;

  return (
    <div className="policy-area-page">
     
      <MultiStepBar steps={steps} currentStep={currentStep} />

      <div className="match-policy-content-container">
        <div className="policy-header">
          <h1>Select Policy Areas That Interest You</h1>
          <p>
            Choose the issues you care about to personalize your matching
            experience.
          </p>
        </div>

        {errorMessage && <div className="error-message">{errorMessage}</div>}

        <div className="selection-controls">
          <button className="select-btn select-all" onClick={selectAll}>
            Select All
          </button>
          <button className="select-btn deselect-all" onClick={deselectAll}>
            Deselect All
          </button>
          <div className="selected-count">
            {selectedCount} of {POLICY_AREAS.length} areas selected
          </div>
        </div>

        <div className="policy-areas-grid">
          {POLICY_AREAS.map((area) => (
            <div
              key={area.id}
              className={`policy-area-card ${
                selectedAreas[area.id] ? "selected" : ""
              }`}
              onClick={() => toggleArea(area.id)}
            >
              <div className="area-icon">
                <div className={area.icon}></div>
              </div>
              <div className="area-content">
                <h3>{area.name}</h3>
                <p>{area.description}</p>
              </div>
              <div className="area-checkbox">
                <div className="checkbox">
                  {selectedAreas[area.id] && (
                    <span className="checkmark">✓</span>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="continue-container">
          <button
            className="btn btn-primary continue-btn"
            onClick={handleContinue}
          >
            Continue to Swiping
          </button>
          <Link to="/" className="btn btn-secondary back-btn">
            Go Back
          </Link>
        </div>
      </div>
    </div>
  );
}
